module.exports = __webpack_public_path__ + "img/unblockClient.81c24279.svg";